import React from 'react';
import { FiArrowRight } from 'react-icons/fi';

import { images } from '../../constants';

import './Header.css';

const highlights = [
  { href: '#caffetteria', label: 'Caffetteria e colazioni' },
  { href: '#pausa-pranzo', label: 'Pausa pranzo con menù e fuori menù' },
  { href: '#aperitivi', label: 'Aperitivi su misura' },
];

const Header = () => (
  <section className="hero" id="home" aria-labelledby="hero-title">
    <div className="container hero__grid">
      <div className="hero__text">
        <p className="eyebrow">Il tuo bar a Ceriano Laghetto</p>
        <h1 id="hero-title" className="display hero__title">
          L’angolo verde di Mauro e Aurora
        </h1>
        <p className="hero__payoff">Il tuo bar di fiducia.</p>
        <p className="hero__description">
          Nel cuore di Ceriano Laghetto, un luogo accogliente dove iniziare bene la giornata,
          concedersi una pausa e condividere momenti speciali.
        </p>
        <div className="hero__actions">
          <a href="#caffetteria" className="btn btn--primary">
            Scopri i nostri servizi
            <FiArrowRight aria-hidden="true" />
          </a>
          <a href="#contatti" className="btn btn--secondary">
            Contattaci
          </a>
        </div>
      </div>

      <figure className="hero__figure">
        <img
          src={images.hero.src}
          width={images.hero.width}
          height={images.hero.height}
          alt="Due cappuccini e un croissant su un tavolo di legno, accanto alle vetrate sul verde"
          fetchpriority="high"
          decoding="async"
        />
      </figure>
    </div>

    <ul className="container hero__highlights">
      {highlights.map((item, index) => (
        <li key={item.href}>
          <a href={item.href}>
            <span className="hero__highlight-number" aria-hidden="true">
              0{index + 1}
            </span>
            <span>{item.label}</span>
          </a>
        </li>
      ))}
    </ul>
  </section>
);

export default Header;
